import { computed, watch } from 'vue';

import {
  disconnectConsumer,
  openWsConnection,
  reconnectWithNewUrl,
} from '@/websocket/controller';
import { useTenantsStore } from '@/stores/tenants';

export const useWebsocketController = () => {
  const tenantsStore = useTenantsStore();
  const currentTenant = computed(() => tenantsStore.currentTenant);

  const checkWebsocketConnection = (newAccessToken: string | null, oldAccessToken: string | null) => {
    if (newAccessToken && oldAccessToken && (newAccessToken !== oldAccessToken)) {
      if (currentTenant.value?.id) {
        reconnectWithNewUrl({ isUnsubscribeNeeded: false }).catch(() => {});
      }
    } else if (!newAccessToken && oldAccessToken) {
      disconnectConsumer().catch(() => {});
    }
  };

  watch(() => currentTenant.value?.id, (newValue?: string, oldValue?: string) => {
    if (newValue && (newValue !== oldValue)) {
      reconnectWithNewUrl().catch(() => {});
    }
  });

  return {
    disconnectConsumer,
    openWsConnectionForCurrentTenant: openWsConnection,
    checkWebsocketConnection,
  };
};
